import React, { useState, useEffect } from "react";
import { TrendingJobCard } from "./JobsList";
import axios from "axios";
import AutoPlay from "./AutoPlay";

export default function TrendingAndExpiringJobs() {
  const [activeTab, setActiveTab] = useState("trending");
  const [trendingJobs, setTrendingJobs] = useState([]);
  const [expiringJobs, setExpiringJobs] = useState([]);
  const [loading, setLoading] = useState(true);


 
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const signal = controller.signal;
    
    Promise.all([
      axios.get(constvar.api_url + "jobs?per_page=8", { signal }),
      axios.get(constvar.api_url + "jobs?per_page=8&sort=expiring", { signal }),
    ])
      .then(([trendRes, expRes]) => {
        if (!isMounted) return;
        if (trendRes.data.status === "success")
          setTrendingJobs(trendRes.data.data.data || []);
        if (expRes.data.status === "success")
          setExpiringJobs(expRes.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

// Helper function to apply your custom rules per breakpoint

  const currentJobs = activeTab === "trending" ? trendingJobs : expiringJobs;

    const getBreakpointSettings = (maxSlidesForScreen) => {
    // 1. Cap it at the maximum allowed for this screen size or total jobs
    let computedSlides = Math.min(currentJobs.length, maxSlidesForScreen) || 1;

    // 2. Apply your forced-scroll deduction rule
    if (currentJobs.length > 1 && currentJobs.length <= maxSlidesForScreen) {
      computedSlides = currentJobs.length - 1;
    }

    const shouldScroll = currentJobs.length > computedSlides;

    return {
      slidesToShow: computedSlides,
      infinite: shouldScroll,
      autoplay: shouldScroll,
    };
  };

  // Base settings for desktop (Max 5 slides)
  const desktopSettings = getBreakpointSettings(5);

  const settings = {
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    
    // Spread desktop calculations
    slidesToShow: desktopSettings.slidesToShow,
    infinite: desktopSettings.infinite,
    autoplay: desktopSettings.autoplay,

    responsive: [
      {
        breakpoint: 992, // Tablets/Small Laptops (Max 3 slides)
        settings: {
          ...getBreakpointSettings(3),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768, // Small Tablets (Max 2 slides)
        settings: {
          ...getBreakpointSettings(2),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575, // Mobile Phones (Max 1 slide)
        settings: {
          ...getBreakpointSettings(1),
          slidesToScroll: 1,
        }
      }
    ]
  };
  

  if (!loading && trendingJobs.length === 0 && expiringJobs.length === 0)
    return null;

  return (
    <section className="sf-section sf-section-light sf-training-jobs">
      <div className="sf-container">
        <div className="sf-training-tabs">
          <div
            className={"sf-tab" + (activeTab === "trending" ? " active" : "")}
            onClick={() => setActiveTab("trending")}
          >
            Trending Jobs
          </div>
          <div
            className={"sf-tab" + (activeTab === "expiring" ? " active" : "")}
            onClick={() => setActiveTab("expiring")}
          >
            Expiring Soon
          </div>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : currentJobs.length > 0 ? (
          // <div className="sf-jobs-grid">
            <AutoPlay key={`${activeTab}-${currentJobs.length}`} settings={settings}>
              {currentJobs.map((job) => (
                <TrendingJobCard key={job.id} job={job} />
              ))}
            </AutoPlay>
          // </div>
        ) : (
          <div className="sf-empty">No jobs in this category.</div>
        )}

      </div>
    </section>
  );
}
